'use client';

import { observer } from 'mobx-react';
import React from 'react';
import Fieldset from '~/components/commonUi/Fieldset';
import { CandidateScoreData } from '~/definitions/report';
import { getStore } from '~/mobx/AppStore';

interface CountingVotesReportProps {
    votesList: CandidateScoreData[];
}

const CountingVotesReport = (props: CountingVotesReportProps) => {
    const classNamesTable = `table-md w-full text-gray-900 leading-[27px] mt-4 mb-4`;
    const classNamesHead = `bg-custom-gray-05 align-top`;
    const classNamesHeadCell = `text-left`;
    const classNamesRow = ` border-b border-gray-300`;
    const classNamesRowCell = `text-center`;

    const renderCountingVotesList = () => {
        const items: JSX.Element[] = [];

        props.votesList?.forEach((vote, index) => {
            let classNamesRowBg = '';
            if (index % 2 === 0) {
                classNamesRowBg = ` bg-[#e3e3e3]`;
            }
            items.push(
                <tr key={`vote-row-${index}`} className={classNamesRow + classNamesRowBg}>
                    <td>{vote.name}</td>
                    <td></td>
                    <td className={classNamesRowCell}>{vote.vote_count.web}</td>
                    <td className={classNamesRowCell}>{vote.vote_count.stand}</td>
                    <td className={classNamesRowCell}>{vote.total_vote_count}</td>
                </tr>
            );
        });

        return items;
    };

    return (
        <div className="vote-adm-cand overflow-x-auto">
            <Fieldset title={'Opptelling av stemmer fra butikk'}>
                <table className={classNamesTable}>
                    <thead>
                        <tr className={classNamesHead}>
                            <th className={classNamesHeadCell}>Navn</th>
                            <th>Stemmer fra</th>
                            <th>WEB</th>
                            <th>STAND</th>
                            <th>Totalt</th>
                        </tr>
                    </thead>
                    <tbody>{renderCountingVotesList()}</tbody>
                </table>
            </Fieldset>
        </div>
    );
};

const CountingVotesReportWithStore = () => {
    const { reportStore } = getStore();

    return <CountingVotesReport votesList={reportStore.votesList} />;
};

export default observer(CountingVotesReportWithStore);
